import React from "react";

export default function About() {
  return (
    <section>
      <div className="container">
        <h2>À propos de GoalFit</h2>
        <p style={{ opacity: 0.7 }}>
          GoalFit a été conçu pour vous aider à transformer votre vie grâce à des entraînements
          structurés, des plans personnalisés et des analyses intelligentes de vos performances.
        </p>
      </div>
    </section>
  );
}
